import * as React from "react"
import { Box } from "@mui/material"

import { STOCK_STATUS } from "../../@constants"
import { NotAllowedBlock } from "@components"


export default function daysStockColumn() {
	return {
		name: 'lastStockDays',
		label: 'Days since last in stock',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'wrap', maxWidth: 50 }
			}),
			customBodyRowRender: (value, row) => <Box sx={{
				color: row.stock === STOCK_STATUS.STOCK && value === 0 ? "text.disabled" : 'text.primary',
				textAlign: 'center'
			}}>
				{ value === null ? <NotAllowedBlock /> : value}
			</Box>
		}
	}
}